(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["language-selector"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', event => {
  if (!event.target.matches('.language-select')) return;
  if (event.target.hasAttribute('data-password-selector')) {
    const path = event.target.selectedOptions[0]?.dataset.passwordUrl;
    if (path) {
      const destination = new URL(path, window.location.origin);
      const previewTheme = new URLSearchParams(window.location.search).get('preview_theme_id');
      if (previewTheme) destination.searchParams.set('preview_theme_id', previewTheme);
      window.location.assign(destination.pathname + destination.search);
      return;
    }
  }
  if (event.target.form) event.target.form.requestSubmit();
});
  } catch(e) { console.error(e); }
})();

})();
